import React from "react";
import useProjectActions from "../hooks/useProjectActions";
import ProjectForm from "./ProjectForm";

import useFirebaseKilns from "../hooks/useFirebaseKilns";
import useFirebasePreferences from "../hooks/useFirebasePreferences";

const ProjectCreatePage = () => {
  const { createProject } = useProjectActions();
  const preferences = useFirebasePreferences();

  const kilns = useFirebaseKilns();
  const first_kiln = kilns && Object.values(kilns)[0];

  if (!first_kiln) {
    return <div>Please create a kiln first</div>;
  }

  const handleSubmit = (formValues: any) => {
    createProject(formValues);
  };

  return (
    <div>
      <ProjectForm
        onSubmit={handleSubmit}
        initialValues={{
          name: "",
          width: "",
          depth: "",
          photos: [],
          kiln: first_kiln.id,
          glass: preferences?.glass_type || "Bullseye",
          thickness: "6",
          stars: 2.5,
          notes: "",
          length_unit: "mm",
          tags: [],
          sale_status: "",
          material_cost: "",
          firing_cost: "",
          labour_cost: "",
          sale_price: "",
          sold_to: "",
        }}
      />
    </div>
  );
};

export default ProjectCreatePage;
